import NodeAirHandlingUnit from './node-air-handling-unit';

export default NodeAirHandlingUnit;
